import React from 'react';
import { Box, Button, Container, Heading, HStack, Icon, Stack, Text, VStack } from '@chakra-ui/react';
import { PhoneIcon, MapPinIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { brand, images, whatsappHref } from '../data/brand';
const trustItems = [{
  icon: MapPinIcon,
  label: 'Miami, Florida'
}, {
  icon: ShieldCheckIcon,
  label: 'Consultas confidenciales'
}, {
  icon: ClockIcon,
  label: 'Atención por WhatsApp y teléfono'
}];
export function Hero() {
  return <Box as="section" id="inicio" position="relative" bg="plum.950" backgroundImage={`url(${images.hero})`} backgroundSize="cover" backgroundPosition="center" overflow="hidden" data-id="element-143" data-mp="xbp8yts4ze98">
      <Box position="absolute" inset={0} bg="linear-gradient(0deg, rgba(13,6,19,0.94), rgba(13,6,19,0.74))" aria-hidden="true" data-id="element-144" data-mp="nekmstyajisf" />
      <Container maxW="76rem" px={{
      base: 4,
      md: 6
    }} position="relative" data-id="element-145" data-mp="380vxpuaomnbk">
        <VStack spacing={{
        base: 6,
        md: 8
      }} py={{
        base: 14,
        md: 24
      }} textAlign="center" maxW="50rem" mx="auto" data-id="element-146" data-mp="3j8977bv8e9p0">
          <Text fontSize="xs" fontWeight={600} letterSpacing="0.22em" textTransform="uppercase" color="gold.300" data-id="element-147" data-mp="39alaige2es47">
            Templo de Ayuda Esotérica
          </Text>

          <Heading as="h1" fontSize={{
          base: '2rem',
          sm: '2.6rem',
          md: '3.4rem'
        }} lineHeight={1.14} color="cream.50" data-id="element-148" data-mp="30h9d5w8vq9ov">
            AMARRES DE AMOR Y HECHIZOS MÁGICOS: ORIENTACIÓN ESPIRITUAL
          </Heading>

          <Text fontFamily="heading" fontSize={{
          base: 'xl',
          md: '2xl'
        }} color="gold.200" fontStyle="italic" data-id="element-149" data-mp="2viewazuh2v7e">
            Nuestros guías espirituales iluminan tu camino.
          </Text>

          <Text fontSize={{
          base: 'md',
          md: 'lg'
        }} color="plum.100" maxW="42rem" data-id="element-150" data-mp="2ljz1alsbr1sm">
            Somos especialistas en prácticas espirituales, hechizos y amarres tradicionales. A través
            de nuestra experiencia y orientación personalizada, ofrecemos acompañamiento para quienes
            desean explorar diferentes aspectos de su vida personal y sentimental.
          </Text>

          <Stack direction={{
          base: 'column',
          sm: 'row'
        }} spacing={3} w={{
          base: '100%',
          sm: 'auto'
        }} pt={2} data-id="element-151" data-mp="deq6q9xkgtzv">
            <Button as="a" href={whatsappHref()} target="_blank" rel="noopener noreferrer" variant="whatsapp" size="lg" h={{
            base: '3.5rem',
            md: '3.75rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} w={{
            base: '100%',
            sm: 'auto'
          }} leftIcon={<WhatsAppIcon size={21} data-id="element-153" data-mp="3hqu2kaecg816" />} data-id="element-152" data-mp="161jc55lwihg7">
              CONSULTAR POR WHATSAPP
            </Button>
            <Button as="a" href={brand.phoneHref} variant="goldSolid" size="lg" h={{
            base: '3.5rem',
            md: '3.75rem'
          }} px={8} fontSize={{
            base: 'sm',
            md: 'md'
          }} w={{
            base: '100%',
            sm: 'auto'
          }} leftIcon={<PhoneIcon size={18} aria-hidden="true" data-id="element-155" data-mp="2b1hl0lvvx6bh" />} data-id="element-154" data-mp="1xa431cdmkgik">
              LLAMAR AHORA
            </Button>
          </Stack>

          <Stack direction={{
          base: 'column',
          md: 'row'
        }} spacing={{
          base: 2,
          md: 8
        }} pt={{
          base: 2,
          md: 4
        }} align="center" data-id="element-156" data-mp="2g258wyoth71h">
            {trustItems.map(item => <HStack key={item.label} spacing={2} color="plum.100" data-id="element-157" data-mp="2u03lbyjkutec">
                <Icon as={item.icon} boxSize="1rem" color="gold.300" aria-hidden="true" data-id="element-158" data-mp="2tx7o6cfk08qy" />
                <Text fontSize="sm" data-id="element-159" data-mp="uokdjna0fr69">{item.label}</Text>
              </HStack>)}
          </Stack>
        </VStack>
      </Container>
    </Box>;
}